import { render, staticRenderFns } from "./ScheduleIcon.vue?vue&type=template&id=c5d7b89e&scoped=true&"
import script from "./ScheduleIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ScheduleIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d7b89e",
  null
  
)

export default component.exports